import React from 'react';

const LoadingSpinner = () => {
  return (
    <div className="fixed inset-0 bg-white z-50 flex items-center justify-center">
      <style>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        .loading-container {
          animation: fadeIn 0.3s ease-in;
        }
      `}</style>

      <div className="loading-container flex flex-col items-center">
        {/* Logo Spinner */}
        <div style={{
          width: '80px',
          height: '80px',
          position: 'relative',
        }}>
          <svg viewBox="0 0 50 50" style={{
            width: '100%',
            height: '100%',
            animation: 'spin 1.5s linear infinite',
            filter: 'drop-shadow(0 4px 8px rgba(0, 188, 212, 0.4))',
          }}>
            <defs>
              <linearGradient id="loadingLogoGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" style={{ stopColor: '#00BCD4', stopOpacity: 1 }} />
                <stop offset="50%" style={{ stopColor: '#0891B2', stopOpacity: 1 }} />
                <stop offset="100%" style={{ stopColor: '#2563EB', stopOpacity: 1 }} />
              </linearGradient>
            </defs>
            <g>
              <path
                fill="url(#loadingLogoGradient)"
                stroke="url(#loadingLogoGradient)"
                strokeWidth="1"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="
                M 11.2,22.6
                L 3.3,21.2
                A 22 22 0 0 1 44.1,14.0
                L 47.5,12.0
                L 42.7,21.9
                L 33.7,20.0
                L 37.1,18.0
                A 14 14 0 0 0 11.2,22.6
                Z" />

              <path
                fill="url(#loadingLogoGradient)"
                stroke="url(#loadingLogoGradient)"
                strokeWidth="1"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="
                M 38.8,27.4
                L 46.7,28.8
                A 22 22 0 0 1 6.0,36.0
                L 2.5,38.0
                L 7.3,28.1
                L 16.3,30.0
                L 12.9,32.0
                A 14 14 0 0 0 38.8,27.4
                Z" />
            </g>
          </svg>
        </div>

      </div>
    </div>
  );
};

export default LoadingSpinner;
